import { convertLocale } from './convertLocale';
import { toUtcNoon } from './toUtcNoonISOString';

export function getUkraineDate(
  date: string,
  locale: string | undefined,
): { date: string, year: string } {
  const dateLocale = convertLocale(locale);

  return {
    date: new Intl.DateTimeFormat(dateLocale, {
      month: 'long',
      day: 'numeric',
    }).format(toUtcNoon(new Date(date), 'utc')),
    year: new Intl.DateTimeFormat(dateLocale, {
      year: 'numeric',
    }).format(toUtcNoon(new Date(date), 'utc')),
  };
}
